import { render, staticRenderFns } from "./OperationUpdateDetailsContainer.vue?vue&type=template&id=b085f700"
import script from "./OperationUpdateDetailsContainer.vue?vue&type=script&lang=js"
export * from "./OperationUpdateDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports